export default __webpack_public_path__ + "static/media/jobs-img.6ebc2b51.png";